document.addEventListener( 'DOMContentLoaded', function () {
	const ANIMATION_MS         = 400;
	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
	const TABLET_MQ            = window.matchMedia( '(max-width: 991px)' );
	const MOBILE_MQ            = window.matchMedia( '(max-width: 551px)' );
	const TOTAL_COLS           = 7;
	const NAV_LABELS_BY_COLS   = {
		2: [ 'Пн — Вт', 'Ср — Чт', 'Пт — Сб', 'Вс' ],
		3: [ 'Пн — Ср', 'Чт — Сб', 'Вс' ],
	};

	const section = document.querySelector( '.home-calendar' );

	if ( ! section ) {
		return;
	}

	const getVisibleCols = () => ( MOBILE_MQ.matches ? 2 : 3 );

	const viewport     = section.querySelector( '[data-home-calendar-viewport]' );
	const grid         = section.querySelector( '[data-home-calendar-grid]' );
	const prevBtn      = section.querySelector( '[data-home-calendar-prev]' );
	const nextBtn      = section.querySelector( '[data-home-calendar-next]' );
	const labelEl      = section.querySelector( '[data-home-calendar-nav-label]' );
	const monthSelect  = section.querySelector( '[data-home-calendar-month]' );
	const monthWrap    = section.querySelector( '.home-calendar__month' );
	const templatesEl  = section.querySelector( '[data-home-calendar-templates]' );
	const ajaxUrl      = section.dataset.ajaxUrl;
	const nonce        = section.dataset.nonce;

	let page      = 0;
	let isLoading = false;

	const updateNav = () => {
		const visibleCols = getVisibleCols();
		const maxPage     = Math.ceil( TOTAL_COLS / visibleCols ) - 1;
		const labels      = NAV_LABELS_BY_COLS[ visibleCols ] || [];

		if ( page > maxPage ) {
			page = maxPage;
		}

		if ( labelEl ) {
			labelEl.textContent = labels[ page ] || '';
		}

		if ( prevBtn ) {
			prevBtn.disabled = page === 0;
		}

		if ( nextBtn ) {
			nextBtn.disabled = page >= maxPage;
		}
	};

	const updateColumns = () => {
		if ( ! viewport || ! grid ) {
			return;
		}

		if ( ! TABLET_MQ.matches ) {
			grid.style.removeProperty( 'transform' );
			grid.style.removeProperty( 'width' );
			grid.style.removeProperty( '--calendar-col-width' );
			page = 0;
			updateNav();
			return;
		}

		const visibleCols = getVisibleCols();
		const gap         = parseFloat( window.getComputedStyle( grid ).columnGap || window.getComputedStyle( grid ).gap ) || 10;
		const colWidth    = ( viewport.clientWidth - ( visibleCols - 1 ) * gap ) / visibleCols;
		const offset      = page * visibleCols * ( colWidth + gap );

		grid.style.setProperty( '--calendar-col-width', `${colWidth}px` );
		grid.style.width = `${TOTAL_COLS * colWidth + ( TOTAL_COLS - 1 ) * gap}px`;
		grid.style.transform = `translateX(-${offset}px)`;
		updateNav();
	};

	const resetColumns = () => {
		page = 0;
		updateColumns();
	};

	const initDayEventSliders = () => {
		section.querySelectorAll( '[data-home-calendar-events]' ).forEach( ( eventsEl ) => {
			if ( eventsEl.dataset.sliderReady === '1' ) {
				return;
			}

			const track   = eventsEl.querySelector( '[data-home-calendar-track]' );
			const slides  = [ ...eventsEl.querySelectorAll( '.home-calendar__events-slide' ) ];
			const bullets = [ ...eventsEl.querySelectorAll( '.home-calendar__pagination-item' ) ];

			eventsEl.dataset.sliderReady = '1';

			if ( slides.length <= 1 || ! bullets.length || ! track ) {
				return;
			}

			let currentIndex = slides.findIndex( ( slide ) => slide.classList.contains( 'is-active' ) );

			if ( currentIndex < 0 ) {
				currentIndex = 0;
			}

			let isAnimating = false;

			const measureSlide = ( slide ) => {
				slide.classList.add( 'is-measuring' );
				const height = slide.offsetHeight;
				slide.classList.remove( 'is-measuring' );

				return height;
			};

			const updateBullets = ( index ) => {
				bullets.forEach( ( bullet, bulletIndex ) => {
					const isActive = bulletIndex === index;

					bullet.classList.toggle( 'is-active', isActive );
					bullet.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
				} );
			};

			const setActiveSlideInstant = ( index ) => {
				slides.forEach( ( slide, slideIndex ) => {
					slide.classList.toggle( 'is-active', slideIndex === index );
				} );

				updateBullets( index );
				track.style.height = '';
				currentIndex       = index;
			};

			const setActiveSlide = ( index ) => {
				if ( index === currentIndex || isAnimating ) {
					return;
				}

				if ( prefersReducedMotion ) {
					setActiveSlideInstant( index );
					return;
				}

				const direction    = index > currentIndex ? 'forward' : 'back';
				const currentSlide = slides[ currentIndex ];
				const nextSlide    = slides[ index ];
				const startHeight  = track.offsetHeight;
				const endHeight    = measureSlide( nextSlide );
				const enterClass   = direction === 'forward' ? 'is-enter-from-right' : 'is-enter-from-left';
				const leaveClass   = direction === 'forward' ? 'is-leave-to-left' : 'is-leave-to-right';

				isAnimating = true;
				track.style.height = `${startHeight}px`;

				currentSlide.classList.add( 'is-leaving', leaveClass );
				currentSlide.classList.remove( 'is-active' );

				nextSlide.classList.add( 'is-active', 'is-entering', enterClass );
				updateBullets( index );

				requestAnimationFrame( () => {
					requestAnimationFrame( () => {
						track.style.height = `${endHeight}px`;
						currentSlide.classList.add( 'is-leaving-active' );
						nextSlide.classList.remove( enterClass );
					} );
				} );

				window.setTimeout( () => {
					currentSlide.classList.remove( 'is-leaving', 'is-leaving-active', leaveClass );
					nextSlide.classList.remove( 'is-entering', enterClass );
					track.style.height = '';
					isAnimating        = false;
					currentIndex       = index;
				}, ANIMATION_MS );
			};

			bullets.forEach( ( bullet, index ) => {
				bullet.addEventListener( 'click', () => {
					setActiveSlide( index );
				} );
			} );
		} );
	};

	const closeEventPopup = () => {
		document.querySelector( '[data-event-popup].is-open [data-event-popup-close]' )?.click();
	};

	const syncMonthSelect = () => {
		if ( ! monthSelect?.id ) {
			return;
		}

		const wrapper    = document.querySelector( `[data-custom-for="${ monthSelect.id }"]` );
		const dropdown   = wrapper?.querySelector( '.custom-dropdown' );
		const selectedEl = dropdown?.querySelector( '.custom-dropdown-selected' );
		const option     = monthSelect.options[ monthSelect.selectedIndex ];

		if ( selectedEl && option ) {
			selectedEl.textContent = option.textContent;
		}

		dropdown?.querySelectorAll( '.custom-dropdown-list li' ).forEach( ( li ) => {
			li.classList.toggle( 'active', li.dataset.value === monthSelect.value );
		} );
	};

	let currentMonth = monthSelect?.value || '';

	const loadMonth = async ( month ) => {
		if ( isLoading || ! ajaxUrl || ! nonce || ! month || ! grid || month === currentMonth ) {
			return;
		}

		isLoading = true;
		section.classList.add( 'is-loading' );
		monthWrap?.classList.add( 'is-disabled' );
		monthSelect?.setAttribute( 'disabled', 'disabled' );
		closeEventPopup();

		try {
			const body = new FormData();

			body.append( 'action', 'fd_get_home_calendar' );
			body.append( 'nonce', nonce );
			body.append( 'month', month );

			const response = await fetch( ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			} );

			const data = await response.json();

			if ( ! data.success ) {
				throw new Error( 'calendar-month-failed' );
			}

			grid.innerHTML = data.data.grid || '';
			currentMonth   = month;

			if ( templatesEl ) {
				templatesEl.innerHTML = data.data.templates || '';
			}

			resetColumns();
			initDayEventSliders();
		} catch ( error ) {
			console.error( 'home-calendar:', error );

			if ( monthSelect ) {
				monthSelect.value = currentMonth;
				syncMonthSelect();
			}
		} finally {
			isLoading = false;
			section.classList.remove( 'is-loading' );
			monthWrap?.classList.remove( 'is-disabled' );
			monthSelect?.removeAttribute( 'disabled' );
		}
	};

	prevBtn?.addEventListener( 'click', () => {
		if ( page > 0 ) {
			page -= 1;
			updateColumns();
		}
	} );

	nextBtn?.addEventListener( 'click', () => {
		const maxPage = Math.ceil( TOTAL_COLS / getVisibleCols() ) - 1;

		if ( page < maxPage ) {
			page += 1;
			updateColumns();
		}
	} );

	TABLET_MQ.addEventListener( 'change', resetColumns );
	MOBILE_MQ.addEventListener( 'change', resetColumns );
	window.addEventListener( 'resize', updateColumns );

	if ( monthSelect ) {
		monthSelect.addEventListener( 'change', () => {
			loadMonth( monthSelect.value );
		} );
	}

	updateColumns();
	initDayEventSliders();
} );
